import FolderPage from '@/views/covers/FolderPage'

export default function Folder() {
  return <FolderPage />
}
